import React, { useState, useEffect } from 'react';
// カレンダーライブラリ
import Calendar from 'react-calendar';
// 日付と時刻をパース・検証・操作・表示する最小のモダンブラウザ向けライブラリ
import dayjs from 'dayjs';

// // 祝日ライブラリ
// const holiday_jp = require('@holiday-jp/holiday_jp');

/* ========================================================
カレンダーコンポーネント
=========================================================*/
const SSCalendar = (props) => {
	const { items, current, callChangeMonthState, dev, conf } = props;
	const [monthcnt, setMonthCnt] = useState(current);
	if (dev) console.log("★SSCalendar起動");

	/* ========================================================
	月が変わったらcallChangeMonthState()を使ってApp.jsに通知する
	=========================================================*/
	useEffect(() => {
		callChangeMonthState(monthcnt);
	}, [monthcnt])


	// 本日
	const date = new Date();
	// console.log("本日：" + date);
	// console.log("date.getMonth() = " + (date.getMonth() + 1));
	// console.log("date.getDate() = " + date.getDate());

	// 先月の1日
	const previousM = new Date(date.getFullYear(), date.getMonth() - 1, 1);
	// console.log("先月：" + previousM);
	// console.log("previousM.getFullYear() = " + (previousM.getFullYear()));
	// console.log("previousM.getMonth() = " + (previousM.getMonth() + 1));
	// console.log("previousM.getDate() = " + 1);

	// 来月の末日を取得（翌々日の前日）
	const lastDay = new Date(date.getFullYear(), date.getMonth() + 1 + 1, 0).getDate();

	// 翌月の末日
	const nextM = new Date(date.getFullYear(), date.getMonth() + 1, lastDay);
	// console.log("翌月：" + nextM);


	let monthDays = {};

	// /* ========================================================
	// 祝日のクラス設定
	// =========================================================*/
	// const holidays = holiday_jp.between(previousM, nextM);
	// for (let i in holidays) {
	// 	const d = new Date(holidays[i]['date']);
	// 	// console.log(Util.formatDate(d, DATEFORMAT3))
	// 	monthDays[Util.formatDate(d, DATEFORMAT2)] = { is_holiday: true };
	// }

	/* ========================================================
	商品のクラス設定
	=========================================================*/
	for (let i in items) {
		const d = new Date(items[i].release);
		// console.log("items key:"+Util.formatDate(d, DATEFORMAT2))
		monthDays[dayjs(d).format('YYYYMMDD')] = { is_item: true };
	}

	/* ========================================================
	月の変更イベント
	=========================================================*/
	// react-calendarのProp
	// onActiveStartDateChange(action, activeStartDate, value, view)
	const onActiveStartDateChange = (arg) => {
		// 次の月
		if (arg["action"] === "next") {
			const cnt = monthcnt < 2 ? monthcnt + 1 : monthcnt;
			if (dev) console.log('Next:' + cnt);
			setMonthCnt(cnt);

			// 次の月を非表示
			if (cnt === 2) document.querySelector(".react-calendar__navigation__next-button").classList.add("-disable");
			// 前の月を表示
			if (cnt !== 0) document.querySelector(".react-calendar__navigation__prev-button").classList.remove("-disable");


			// 前の月
		} else if (arg["action"] === "prev") {
			const cnt = monthcnt > 0 ? monthcnt - 1 : monthcnt;
			if (dev) console.log('Prev:' + cnt);
			setMonthCnt(cnt);

			// 次の月を表示
			if (cnt !== 2) document.querySelector(".react-calendar__navigation__next-button").classList.remove("-disable");
			// 前の月を非表示
			if (cnt === 0) document.querySelector(".react-calendar__navigation__prev-button").classList.add("-disable");
		}
	}


	/* ========================================================
	日付クリック
	=========================================================*/
	const onChange = (date) => {
		let d = dayjs(date).format('YYYY-MM-DD');
		if (dev) console.log("日付クリック:#d" + d);

		const elem = document.querySelector("#d" + d);
		if (!elem) return;

		// getBoundingClientRect().top：ブラウザの表示領域の左上を基点として、そこからターゲットの位置までの距離
		let targetTop = elem.getBoundingClientRect().top + window.scrollY;
		console.log("getBoundingClientRect:" + elem.getBoundingClientRect().top);
		console.log("window.scrollY:" + window.scrollY);

		if (window.scrollY == 0) targetTop = targetTop;
		console.log("targetTop:" + targetTop);

		window.scrollTo({
			top: targetTop - conf["headerheight"],
			behavior: 'smooth'
		});

		return;
	}

	/* ========================================================
	日付のクラスを付与 (祝日用)
	=========================================================*/
	const getTileClass = ({ date, view }) => {
		// 月表示のときのみ
		if (view !== 'month') {
			return '';
		}
		// 祝日クラスの付与
		const day = dayjs(date).format('YYYYMMDD');
		// const class1 = (monthDays[day] && monthDays[day].is_holiday) ?
		// 	'holiday' : '';
		const class2 = (monthDays[day] && monthDays[day].is_item) ?
			"select js-smooth_scroll" : "";

		return class2;
		// return (class1 && class2) ? class1 + ' ' + class2 : class1 + class2;
	}

	// /* ========================================================
	// 日付の内容を出力
	// =========================================================*/
	// const getTileContent = ({ date, view }) => {
	// 	// 月表示のときのみ
	// 	if (view !== 'month') {
	// 		return null;
	// 	}
	// 	const day = Util.formatDate2(date);
	// 	return (
	// 		<p>
	// 			<br />
	// 			{(monthDays[day] && monthDays[day].text) ?
	// 				monthDays[day].text : ' '
	// 			}
	// 		</p>
	// 	);
	// }


	// JSX
	return (
		<div className="bg01">
			<div className="areainner">
				<div className="ttlbox">
					<h2>COSMETICS CALENDAR</h2>
					<p className="sub">新作コスメカレンダー</p>
				</div>
				<article className="areakv">
					<section className="mv pc">
						<img src={conf["cdn"] + conf["docroot"] + "/static/img/illust.png?d=" + dayjs(new Date()).format('YYYYMMDDHH')} alt="COSMETICS CALENDAR" />
					</section>
					<section className="wrapcalendar">
						<section className="mv sp"><img src={conf["cdn"] + conf["docroot"] + "/static/img/illust_sp.png?d=" + dayjs(new Date()).format('YYYYMMDDHH')} alt="COSMETICS CALENDAR" /></section>
						<Calendar
							locale="ja-JP"
							value={date}
							calendarType="US"
							minDate={previousM}
							maxDate={nextM}
							formatDay={(locale, date) => dayjs(date).format('D')}
							formatShortWeekday={(locale, date) => dayjs(date).format('ddd').toUpperCase()}
							formatMonthYear={(locale, date) => <h2 className="ttl mg0"><span className="month">{dayjs(date).format('MMM')}</span><span className="day">{dayjs(date).format('M')}</span><span className="year">{dayjs(date).format('YYYY')}</span></h2>}
							tileClassName={getTileClass}
							// tileContent={getTileContent}
							nextLabel=""
							prevLabel=""
							maxDetail="month"
							minDetail="month"
							next2Label={null}
							prev2Label={null}
							onActiveStartDateChange={onActiveStartDateChange}
							onChange={onChange}
						/>
					</section>
				</article>
			</div>
		</div >
	);
}

export default SSCalendar;
